import { render, staticRenderFns } from "./ClientCreateFormFields.vue?vue&type=template&id=bd3b8e50"
import script from "./ClientCreateFormFields.vue?vue&type=script&lang=js"
export * from "./ClientCreateFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports